import script from "./NavbarCom.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarCom.vue?vue&type=script&setup=true&lang=js"

import "./NavbarCom.vue?vue&type=style&index=0&id=cbf709ce&lang=css"

const __exports__ = script;

export default __exports__